import { type GCPResource, type OperationPointer } from "@doitintl/cmp-models";

export const PROJECT_ID_VARIATIONS = ["projectId", "projectsId", "appsId", "project"];

export function getGCPPermissions(operation: OperationPointer, preExistentPermissions: string[] | undefined) {
  if (preExistentPermissions) {
    return preExistentPermissions;
  }
  const idSegments = operation.id.split(".");
  const [resource, method] = idSegments.slice(-2);

  // Adjust the resource name for logging service
  const permissionResource = operation.service === "logging" && resource === "entries" ? "logEntries" : resource;

  return [`${operation.service}.${permissionResource}.${method}`];
}

export enum GCPHierarchicalResource {
  ORGANIZATION = "organization",
  PROJECT = "project",
}

export function parseServiceAccountResource(resource: string): [GCPResource | null, string | null] {
  if (resource.startsWith("organizations/")) return ["organizations", resource.replace("organizations/", "")];
  if (resource.startsWith("projects/")) return ["projects", resource.replace("projects/", "")];
  return [null, null];
}
